<template>
    <div class="ui menu">
      <Logo></Logo>
      <div class="right menu">
        <div class="item">
          <button class="ui basic button">
            <router-link to="/Admin">Admin</router-link>
          </button>
        </div>
      </div>
    </div>
</template>

<script>
import Logo from './Logo.vue';
export default {
  name: 'app',
  components: {Logo}
}
</script>



// WEBPACK FOOTER //
// src/components/Menubar.vue